import ServerRequestUtil from '../utils/ServerRequestUtil';

export default new class {

    constructor() {
    }

    async getReserveAubeCoinStakingSettingHistory() {
      return ServerRequestUtil.get('/api/app/aube-coin/reserve-setting-history');
    }

    async setReserveAubeCoinStakingSettingHistory(registrationData) {
      return ServerRequestUtil.post('/api/app/aube-coin/reserve-setting-history/set', {...registrationData});
    }

    async getAubeCoinStakingApplyInfo() {
        return ServerRequestUtil.get('/api/app/membership/aubeCoinStakingApplyInfo');
    }
}
